import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Brand } from 'src/app/assabil-kernel/models/entities/control-tables/brand';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { BrandRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/brand-request';


@Component({
  selector: 'app-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss']
})

export class BrandListComponent extends BasePage2<Brand> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  brands: Brand[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location,
      protected controlService    : ControlTablesService) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'brand';
  }
  // ---------------------------------------------------

  
  // ---------------------------------------------------
  getRows(): Brand[] {
      return this.brands;
  }
  // ---------------------------------------------------


  // ---------------------------------------------------
  saveRow(row: Brand): Promise<Brand> {
    let request: BrandRequest = new BrandRequest(this.controlService.getUserInfo());
    request.brand = row;
    return this.controlService.save(this.entityName, request);
}
  // ---------------------------------------------------

    //----------------------------------------------------------------------
    new(){
        let entity : Brand = new Brand();
        entity.inserted = true;
        entity.edit = true;
        this.brands.push(entity);
        this.brands = [...this.brands];
        }
       
   //----------------------------------------------------------------------
  loadData() {
    let request: BaseRequest = new BaseRequest(this.controlService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.brands = result;
    })
  }
  // ---------------------------------------------------

}